import { Formik, Form, Field, ErrorMessage } from "formik";
import { Button } from "react-bootstrap";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postData } from "../../../API"; // Use your API utility

function CategoryAdd({ addDetails = {}, setEditShow, fetchData }) {
  const initialValues = {
    rtId: addDetails?.rtId || 0,
    categoryName: addDetails?.categoryName || "",
    isActive: addDetails?.isActive ?? true,
  };

  const validationSchema = Yup.object({
    categoryName: Yup.string().required("Category Name is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const res = await postData("RateCategory/AddCategories", values);
      if (res.statusCode === 200) {
        toast.success("Category added successfully!");
        fetchData();
        setEditShow(false);
      } else {
        toast.error(res.message || "Failed to add category");
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue, isSubmitting }) => (
        <Form>
          <div className="d-flex row justify-content-between m-4">
            <div className="form-group col-md-6">
              <label htmlFor="categoryName">
                Category Name<span className="text-danger">*</span>
              </label>
              <Field
                name="categoryName"
                type="text"
                placeholder="Enter Category Name"
                className="form-control"
              />
              <ErrorMessage
                name="categoryName"
                component="div"
                className="text-danger"
              />
            </div>

            <div className="form-group col-md-6 ml-4">
              <label>Status</label>
              <div className="row d-flex justify-content-center align-items-center">
                <div className="col-md-6">
                  <label className="form-check-label">
                    <Field
                      type="radio"
                      name="isActive"
                      value="true"
                      checked={values.isActive === true}
                      onChange={() => setFieldValue("isActive", true)}
                      className="form-check-input"
                    />
                    Active
                  </label>
                </div>
                <div className="col-md-6">
                  <label className="form-check-label">
                    <Field
                      type="radio"
                      name="isActive"
                      value="false"
                      checked={values.isActive === false}
                      onChange={() => setFieldValue("isActive", false)}
                      className="form-check-input"
                    />
                    Inactive
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div style={{ textAlign: "center", margin: "4px" }}>
            <Button type="submit" variant="primary" disabled={isSubmitting}>
              Submit
            </Button>
          </div>
        </Form>
      )}
    </Formik>
    <ToastContainer />
    </>
  );
}

export default CategoryAdd;
